module.exports = __webpack_public_path__ + "assets/img/ZC.e3935737.png";